import { axiosAjax } from '@app/src/config/axios';
import { BrandVehicleModel } from '@app/src/views/StepOne/form/models/brandVehicle';
import { hydrateData } from '@app/src/views/StepOne/form/state/brandVehicle/hydrators';

export const brandVehicleTopService = {
  async get(vehicleId: number, flag?: string): Promise<BrandVehicleModel[]> {
    try {
      let uri = process.env.API_VEHICLE_BRAND_TOP
                  .replace(':vehicleId', '' + vehicleId);
      if (flag === 'all') {
        uri = process.env.API_VEHICLE_BRAND_TOP_ALL
      }
      const { data } = await axiosAjax.get(uri);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
